import { ENVIRONMENT } from 'config/settings';

const isProd = () => ENVIRONMENT === 'prod';

export const consoleHelper = {
  log: data => !isProd() && console.log(data),
  warn: data => !isProd() && console.warn(data),
  error: data => !isProd() && console.error(data)
};
